import script from "./SingleTableActivityLog.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleTableActivityLog.vue?vue&type=script&setup=true&lang=js"

import "./SingleTableActivityLog.vue?vue&type=style&index=0&id=af429cc6&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af429cc6"]])

export default __exports__